import styled from 'styled-components';

const SponsoredArticleText = styled.small`
    color: ${(props) => props.theme.colors.blueGrey};
    line-height: 12px;
`;

export default SponsoredArticleText;
